import { render, staticRenderFns } from "./AssessmentView.vue?vue&type=template&id=42ce5514&"
import script from "./AssessmentView.vue?vue&type=script&lang=js&"
export * from "./AssessmentView.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentView.vue?vue&type=style&index=0&id=42ce5514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports